let env = {
  PERSON_NAME: "pprotaxsolutions",
  PERSON_MOBILE: "3333333338",
  PERSON_EMAIL: "pprotaxsolutions@gmail.com",
  PERSON_QUERY: "protaxsolutions@gmail.com",
  LOGIN_EMAIL: "pprotaxsolutions@gmail.com",
  LOGIN_PASSWORD: "neeraj_@123",
};

export default env;